import React from "react";
import { SelectionGroup,SelectionItem } from "../Selection/Selection";
import { setAmenities } from "../../ReduxSlices/SearchSlice";

export const BedFilter = ({ amenities, dispatch }) => {
    return (
      <div>
        <div className="text-[14px] sm:text-base">Beds</div>
        <SelectionGroup
          defaultItem={amenities.bed}
          className="flex gap-[6px] sm:gap-[8px] text-[#D5D5D5] my-[10px] sm:my-[12px] flex-wrap"
        >
          {['Any', '1', '2', '3', '4', '5', '6', '7+'].map((value, index) => (
            <SelectionItem
              key={value}
              SelectedItem={
                <div className="w-full min-w-[40px] sm:min-w-[50px] py-[6px] sm:py-[8px] border-[1px] rounded-[12px] sm:rounded-[16px] text-center border-[#5B1DEE] text-[#5B1DEE] text-[12px] sm:text-sm">
                  {value}
                </div>
              }
              UnselectedItem={
                <div
                  className="w-full min-w-[40px] sm:min-w-[50px] py-[6px] sm:py-[8px] border-[1px] rounded-[12px] sm:rounded-[16px] text-center text-[12px] sm:text-sm"
                  onClick={() =>
                    dispatch(setAmenities({ ...amenities, bed: index }))
                  }
                >
                  {value}
                </div>
              }
            />
          ))}
        </SelectionGroup>
      </div>
    );
  };
  